import React, { useState } from "react";
import { CustomInputText } from "../../CustomInputText";
import { CustomButtonsForm } from "../../CustomButtonsForm";
import { useForm, Controller } from "react-hook-form";
import { CustomInputSwitch } from "../../CustomInputSwitch";
import { convertirLetraMayus } from "../../../helpers/convertirLetraMayus";

export const UpdateChannelForm = (props) => {

    const { data, action } = props;
    const [activo, setActivo] = useState(data?.activo ? 'Activo' : 'Inactivo');
    const { handleSubmit, control, formState: { errors } } = useForm();

    return (
        <form style={{ margin: '30px 30px 20px 30px', position: 'relative',  width: 420 }} onSubmit={ handleSubmit(action) }>
            <div style={{ height: '60%' }}>

                <Controller 
                    name='canal'
                    control={ control }
                    defaultValue={ convertirLetraMayus(data?.canal) || '' }
                    render={({ field: { onChange, value } }) => (
                        <CustomInputText
                            label="Canal"
                            placeholder=""
                            error={ errors?.canal } 
                            onChange={ onChange }
                            value={ value }
                        />
                    )}
                    
                    rules={{ 
                        required: 'El campo es obligatorio.'  
                    }}
                />

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Controller 
                        name='interno'
                        control={ control }
                        defaultValue={ data?.interno || false }
                        render={({ field: { onChange, value } }) => (
                            <CustomInputSwitch
                                label="¿Es presencial?"
                                onChange={ onChange }
                                value={ value }
                            />
                        )}
                    />

                    <Controller 
                        name='activo'
                        control={ control }
                        defaultValue={ data?.activo || false }
                        render={({ field: { onChange, value } }) => (
                            <CustomInputSwitch
                                label={ activo }
                                onChange={ (e) => {
                                    onChange(e);
                                    e.target.checked ? setActivo('Activo') : setActivo('Inactivo');
                                }}
                                value={ value }
                            />
                        )}
                    />
                </div>
                
            </div>

            <CustomButtonsForm name='Actualizar' />
        </form>
    );
};